import React from 'react';
import { useLanguage } from '../context';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center space-x-1 bg-white/10 rounded-full p-1">
      <button
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 text-xs font-medium rounded-full transition-all duration-300 ${
          language === 'en'
            ? 'bg-white text-black'
            : 'text-white/70 hover:text-white'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
      <button
        onClick={() => setLanguage('fr')}
        className={`px-3 py-1 text-xs font-medium rounded-full transition-all duration-300 ${
          language === 'fr'
            ? 'bg-white text-black'
            : 'text-white/70 hover:text-white'
        }`}
        aria-label="Passer en Français"
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher;
